import React from 'react';
import Modal from '../../components/WhatsAppChat/WaModal';

// Campo de detalhe exibido no modal. `full` faz o campo ocupar a linha inteira
// (util para textos longos: assunto, descricao, feedback).
export interface DetailField {
  label: string;
  value: React.ReactNode;
  full?: boolean;
}

interface RowDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  fields: DetailField[];
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

// Considera "vazio" valores que nao agregam ao detalhe (null/undefined, string
// vazia ou so espacos). Numeros (inclusive 0) e elementos React sao mantidos.
function isEmpty(value: React.ReactNode): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  return false;
}

/**
 * Modal generico de detalhes de uma linha de tabela. Renderiza pares
 * label/valor num grid e oculta os campos sem valor. Aceita `children` para
 * conteudo extra (ex.: tabela das conversas de um agente).
 */
export default function RowDetailModal({
  isOpen,
  onClose,
  title,
  fields,
  children,
  size = 'lg',
}: RowDetailModalProps) {
  const visibleFields = fields.filter(f => !isEmpty(f.value));

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size={size}>
      <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
        {visibleFields.map(f => (
          <div key={f.label} className={f.full ? 'sm:col-span-2' : ''}>
            <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-400">
              {f.label}
            </p>
            <div className="text-sm text-gray-800">{f.value}</div>
          </div>
        ))}
      </div>
      {children && <div className="mt-6">{children}</div>}
    </Modal>
  );
}
